const Skills=()=>(
    <div className="tab-contents active-tab" id="skills">
                <ul>
                  <li>
                    <span>Back-End</span>
                    <br />
                    PostgresSQL, Django, Odoo
                  </li>
                  <li>
                    <span>Front-End</span>
                    <br />
                    JavaScript, HTML, CSS, React
                  </li>
                  <li>
                    <span>Framework</span>
                    <br />
                    Flutter
                  </li>
                  <li>
                    <span>Tools and Methods</span>
                    <br />
                    GitHub, Figma
                  </li>
                  <li>
                    <span>Soft Skills</span>
                    <br />
                    Communication, Teamwork, Conflict
                    Resolution, Adaptability, Perseverance, Determination
                  </li>
                </ul>
              </div>
)
export default Skills;